import React from 'react';
import { Layout } from 'antd';
import { useTranslation } from 'react-i18next';
import uoeLogo from '../../assets/images/UOE.png';

const { Footer } = Layout;

const CommonFooter = () => {
  const { t } = useTranslation();
  return (
    <Footer
      style={{
        textAlign: 'center',
      }}
    >
      <img
        src={uoeLogo}
        alt="The University of Edinburgh"
        style={{ height: 48, width: 'auto', marginBottom: 16, display: 'inline-block' }}
      />
      <div>
        OpenEP|NET ©{new Date().getFullYear()} {t("All Rights Reserved")}.
      </div>
    </Footer>
  );
};

export default CommonFooter;
